export const PAGING_BUTTON_WIDTH = 40; // px
